enum ModalReviewUploadState {
	INACTIVE = 0,
	UPLOAD_SCOPE_AND_TYPE = 1,
	UPLOAD_CONTENTS = 2
}

export { ModalReviewUploadState };
